import { BaseEntity } from '../../../../models';
import { UnidadeNegocio } from '../../../unidade-negocio';
import { Mercado } from '../../../mercado';
import { ItemTipo } from '../../../item-tipo';
import { NaturezaVenda } from '../../../natureza-venda';

export class ClienteUnidadeNegocio implements BaseEntity {
    id: number;
    createdAt: Date;
    idCliente: number;
    idUnidadeNegocio: number;
    unidadeNegocio: UnidadeNegocio;
    idMercado: number;
    mercado: Mercado;
    idNaturezaVenda: number;
    naturezaVenda: NaturezaVenda;
    idItemTipo: number;
    itemTipo: ItemTipo;
}
